import api from './api';
import logger from '../utils/logger';
import { dedupRequest } from '../utils/requestDeduplication';

const CartService = {
  // Get cart items with deduplication
  getCartItems: dedupRequest(async () => {
    try {
      const response = await api.get('/cart');
      return response.data;
    } catch (error) {
      throw error;
    }
  }, 500),

  // Add item to cart
  addToCart: async (item) => {
    try {
      logger.debug('CartService addToCart - Item to be sent to API:', item);
      const response = await api.post('/cart/add', item);
      logger.debug('CartService addToCart - API response:', response.data);
      return response.data;
    } catch (error) {
      logger.error('CartService addToCart - API error:', error);
      throw error;
    }
  },

  // Update cart item quantity
  updateCartItem: async (itemId, quantity) => {
    try {
      const response = await api.post(`/cart/update/${itemId}`, { quantity });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Remove item from cart
  removeCartItem: async (itemId) => {
    try {
      const response = await api.delete(`/cart/remove/${itemId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Clear cart
  clearCart: async () => {
    try {
      const response = await api.delete('/cart/clear');
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  // Clear cart on payment callback with secure verification
  clearCartOnPaymentCallback: async (orderId, provider, reference) => {
    try {
      logger.debug('🧹 CART CLEARING: Sending request to backend', { 
        order_id: orderId, 
        provider, 
        reference 
      });
      
      const response = await api.post('/payments/clear-cart', { 
        order_id: orderId, 
        provider, 
        reference 
      });
      
      logger.debug('🧹 CART CLEARING: Successfully cleared cart in backend', response.data);
      return response.data;
    } catch (error) {
      logger.error('❌ CART CLEARING: Failed to clear cart in backend:', error);
      // Don't throw the error, just log it - we don't want to block the payment flow
      return { success: false, error: error.message };
    }
  },
  
  // Sync cart with backend
  syncCart: async (items) => {
    try {
      const response = await api.post('/cart/sync', { items });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default CartService;
